<div class="white_paper_wrap">
    <div class="paper_top_sections">
        <h1>アカデミックライティングを対象に<br /><span class="OpenSansFonts">Trinka、Grammarly、LanguageTool</span>を比較</h1>
    </div>

    <div class="need_whitePaper_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="need_content_text">
                        <h2>この解説資料について</h2>
                        <div class="HeadingSubLine"></div>
                        <p>一般的な英語については、すでに複数の<a href="/grammar-checker" class="text-link">文法チェック</a>ツールが存在しますが、学術的な英文のライティングや語法、出版適正をチェックできる校正ツールはこれまで存在しませんでした。</p>

                        <p>学術論文の執筆やテクニカルライティングを行うにあたり、どのライティングサポートツール、<a [routerLink]="['/grammar-checker']">文法チェッカー</a>、校正ツールが最もご自分に適しているかの判断材料として、この解説資料をお読みください。</p>

                        <p>この解説資料では、自社調査の具体的なデータに基づき、記述の正確さの判定や出版適正の査定などを行えるTrinkaが学術ライティングに最適なツールであるということを具体的にご説明しています。</p>
                        <div class="download_whitePaper text-center">
                            <a id="downloadThisWhitePaper" href="../../../assets/resources/Trinka_WhitePaper.pdf" download="trinka-vs-grammarly-vs-language-tool">
                                <img src="assets/images/whitePaper_download.png" alt="download - 英文校正">解説資料を無料ダウンロードする</a>
                        </div>
                        <div class="key_takewaye_sections">
                            <h2>解説資料の概要</h2>
                            <div class="row">
                                <div class="col-lg-3 col-md-6">
                                    <div class="takeaways_cards">
                                        <div class="card_overlay"></div>
                                        <div class="cards_headers">
                                            <p>1</p>
                                        </div>
                                        <div class="need_cards_body">
                                            <p>世界中のアカデミックライターや論文著者が抱える問題点の再考</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-6">
                                    <div class="takeaways_cards">
                                        <div class="card_overlay"></div>
                                        <div class="cards_headers">
                                            <p>2</p>
                                        </div>
                                        <div class="need_cards_body">
                                            <p>既存のライティングサポートツールの柔軟性と限界</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-6">
                                    <div class="takeaways_cards">
                                        <div class="card_overlay"></div>
                                        <div class="cards_headers">
                                            <p>3</p>
                                        </div>
                                        <div class="need_cards_body">
                                            <p><span class="OpenSansFonts">Trinka</span>と<span class="OpenSansFonts">Grammarly、LanguageTool</span>の比較検証</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-6">
                                    <div class="takeaways_cards">
                                        <div class="card_overlay"></div>
                                        <div class="cards_headers">
                                            <p>4</p>
                                        </div>
                                        <div class="need_cards_body">
                                            <p><span class="OpenSansFonts">Trinka</span>の優位性を証明</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="sneak_peek_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="sneak_heading">
                        <h2>解説資料のプレビュー</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <section class="whitePaper_slider testimonials">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="center">

                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/comparison_slide.png" alt="英文校正">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/summary_slide.png" alt="英文 チェック ai">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/Grammar_slide.png" alt="文法 チェック">
                        </div>

                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/comparison_slide.png" alt="英文校正">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/summary_slide.png" alt="英文 チェック ai">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/Grammar_slide.png" alt="文法 チェック">
                        </div>

                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/comparison_slide.png" alt="英文校正">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/summary_slide.png" alt="英文校正 ai">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/Grammar_slide.png" alt="ai英文校正">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/comparison_slide.png" alt="ai英文校正">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/summary_slide.png" alt="英文校正 ai">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/Grammar_slide.png" alt="文法 チェック">
                        </div>

                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/comparison_slide.png" alt="ai英文校正">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/summary_slide.png" alt="英文校正 ai">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/Grammar_slide.png" alt="文法 チェック">
                        </div>

                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/comparison_slide.png" alt="文法 チェック">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/summary_slide.png" alt="英文校正 ai">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/Grammar_slide.png" alt="文法 チェック">
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </section>
    <div class="bottomSilderButtons">
        <div class="download_whitePaper text-center">
            <a id="downloadThisWhitePaperFooter" href="../../../assets/resources/Trinka_WhitePaper.pdf" download="trinka-vs-grammarly-vs-language-tool">
                <img src="assets/images/whitePaper_download.png" alt="download - 文法 チェック">
                解説資料を無料ダウンロードする</a>
        </div>
    </div>
</div>